export const isSalesWebPage = () => {
    try {
        return !!document.querySelector('#tm1-sales-app');
    }
    catch (_) { }
    return false;
};
